export default __webpack_public_path__ + "assets/empty-state-with-robots-d99ca8d.svg";